import React, {ReactNode} from 'react';

import {useStore} from 'effector-react';
import {TFunction} from 'i18next';
import {useTranslation} from 'react-i18next';

import {EndlessList, mapListConfig} from 'components/ui-kit/EndlessList2.0';
import {
    Gate,
    listState$,
    filtersChanged,
    sortingsChanged,
    filtersReset,
    filtersSubmit,
    pageIncremented,
} from 'models/documents/checks/grid/list';
import {ChecksAccessors, ChecksGridFormattedRow, ChecksGridRawRow} from 'types';

import {FlexRowElement, ListRow, RowElement, Text} from './styled';

interface Props {
    configFunc: (t: TFunction) => Array<any>;
    dataMapper: (data: ChecksGridRawRow[] | undefined, t: TFunction) => ChecksGridFormattedRow[];
    exportConfig?: {
        exportPending: boolean;
        callback: Function;
    };
    headerControls?: ReactNode;
}

export const ChecksGridList = ({configFunc, dataMapper, exportConfig, headerControls}: Props) => {
    const {t} = useTranslation();
    const {data, filters, sortings, showConfigBlock} = useStore(listState$);
    const mappedData = React.useMemo(() => dataMapper(data?.content, t), [dataMapper, data, t]);

    return (
        <>
            <Gate />
            <EndlessList<ChecksGridFormattedRow>
                rows={mappedData}
                hasMore={data?.hasNext}
                renderRow={(row: ChecksGridFormattedRow) => (
                    <ListRow>
                        <FlexRowElement>
                            <Text>{row[ChecksAccessors.createdDate]}</Text>
                            <Text isGray>{row[ChecksAccessors.status]}</Text>
                        </FlexRowElement>
                        <RowElement>
                            <Text>{row[ChecksAccessors.id]}</Text>
                        </RowElement>
                        <FlexRowElement>
                            <Text>{row[ChecksAccessors.seller]}</Text>
                        </FlexRowElement>
                        <FlexRowElement>
                            <Text isGray>{row[ChecksAccessors.checkType]}</Text>
                        </FlexRowElement>
                    </ListRow>
                )}
                onNextPage={() => pageIncremented()}
                exportConfig={exportConfig}
                configurationBlock={mapListConfig(
                    configFunc(t),
                    filters,
                    sortings,
                    (value) => filtersChanged([value]),
                    filtersSubmit,
                    filtersReset,
                    sortingsChanged,
                    showConfigBlock,
                )}
                headerControls={headerControls}
            />
        </>
    );
};
